import React from 'react';
import { Container } from '@mui/material';
import PageWrapper from '../components/PageWrapper';
import AdmissionInquiryForm from '../components/forms/AdmissionInquiryForm';

const AdmissionInquiry = () => {
    return (
        <PageWrapper configKey="admission-inquiry" pageTitle="Admission Inquiry">
            {(config) => (
                <Container maxWidth="md" sx={{ mt: 3, mb: 3 }}>
                    <AdmissionInquiryForm />
                </Container>
            )}
        </PageWrapper>
    );
};

export default AdmissionInquiry; 